import { Quote } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const stats = [
  { value: "800+", label: "Personnes accompagnées" },
  { value: "15+", label: "Années d'expérience" },
  { value: "350-400", label: "Contacts mailing list" },
];

const testimonials = [
  {
    quote:
      "Un travail qui m'a permis de mettre des mots sur ce qui se rejouait depuis des années. Le cadre est posé, respectueux et précis.",
    name: "Témoignage",
    city: "À venir",
  },
  {
    quote:
      "J'ai pu identifier des dynamiques familiales que je ne voyais pas. L'approche est à la fois rigoureuse et profondément humaine.",
    name: "Témoignage",
    city: "À venir",
  },
  {
    quote:
      "La constellation en groupe a été une expérience marquante. Quelque chose s'est remis en mouvement, sans précipitation.",
    name: "Témoignage",
    city: "À venir",
  },
];

export default function Credibility() {
  return (
    <section
      id="credibilite"
      data-testid="credibility-section"
      className="py-24 md:py-32 bg-[#F3EEF4]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
                — Expérience
              </span>
              <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
                Une expérience de terrain
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg md:text-xl text-[#3A2E6E] font-serif-display italic leading-relaxed max-w-2xl">
                Plus de 800 personnes accompagnées en individuel et en groupe.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-4 text-base text-[#5F6170] max-w-2xl leading-relaxed">
                Une approche construite au fil des années, au contact direct de situations
                humaines complexes.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-5 grid grid-cols-3 gap-4">
            {stats.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.06}>
                <div
                  data-testid={`stat-card-${i}`}
                  className="p-5 bg-white rounded-2xl border border-[#DDD7E2] text-center"
                >
                  <p className="font-serif-display text-3xl text-[#3A2E6E]">{s.value}</p>
                  <p className="text-[11px] uppercase tracking-[0.12em] text-[#5F6170] mt-2 leading-snug">
                    {s.label}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <article
                data-testid={`testimonial-${i}`}
                className="h-full p-8 bg-white rounded-3xl border border-[#DDD7E2] hover:border-[#C98FA3] hover:-translate-y-1 transition-all duration-300 shadow-[0_8px_30px_rgb(0,0,0,0.03)]"
              >
                <Quote className="w-6 h-6 text-[#C98FA3]" />
                <p className="mt-5 text-base text-[#1E1E2A] leading-relaxed font-serif-display text-lg italic">
                  « {t.quote} »
                </p>
                <div className="mt-6 pt-5 border-t border-[#DDD7E2]">
                  <p className="text-sm font-medium text-[#3A2E6E]">{t.name}</p>
                  <p className="text-xs text-[#5F6170] mt-0.5">{t.city}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <p className="mt-12 text-center text-sm text-[#5F6170]">
            Accompagnements en présentiel et à distance · Confidentialité garantie
          </p>
        </Reveal>
      </div>
    </section>
  );
}
